/** Canonical DHC HQ legal URLs — keep in sync with lib/mansion/mansion-legal-urls.ts */
export const MANSION_LEGAL_URLS = {
  privacy: 'https://digitalhustlerscaribbean.com/privacy',
  terms: 'https://digitalhustlerscaribbean.com/terms',
  cookies: 'https://digitalhustlerscaribbean.com/cookies',
};

export const HQ_LEGAL = MANSION_LEGAL_URLS;
